import { MillwrightTask as MillwrightTaskI } from '@/apis/tasks/types/tasksApi';
import { DataItems } from '@/components';
import { formatDateString } from '@/utils';
import { useNavigate, generatePath } from 'react-router';
import {
  BoxAppstore,
  ButtonIcon,
  useWindowSize,
} from '@data-products-and-ai/react-components';
import { FC, useMemo } from 'react';
import { OUTAGE_TASK_ROUTE } from '@/pages/Tasks/routes';

interface MillwrightTaskProps {
  task: MillwrightTaskI;
  outageId: number;
}

export const MillwrightTask: FC<MillwrightTaskProps> = ({ task, outageId }) => {
  const navigate = useNavigate();
  const { width } = useWindowSize();

  const dataItems = useMemo(
    () => [
      {
        key: 'taskDescription',
        label: 'Task Description',
        single: true,
        value: task.taskDescription ?? 'N/A',
      },
      {
        key: 'dateWorked',
        label: 'Date Worked',
        value: task?.dateWorked
          ? formatDateString(task.dateWorked, 'MMMM Do, YYYY')
          : 'N/A',
      },
      {
        key: 'taskNumber',
        label: 'Task Number',
        value: task?.taskID ?? 'N/A',
      },
    ],
    [task, width],
  );

  const handleGoToTask = () => {
    navigate(
      generatePath(OUTAGE_TASK_ROUTE, {
        outageId: outageId.toString(),
        taskId: task.taskID.toString(),
      }),
    );
  };

  return (
    <BoxAppstore>
      <div className="millwright-task">
        <DataItems items={dataItems} />
        <div className="millwright-task__link">
          <ButtonIcon icon="IconLinkExternal" onClick={handleGoToTask} />
        </div>
      </div>
    </BoxAppstore>
  );
};
